import {
  deviceTokenRegisterRequestSchema,
  deviceTokenRegisterResponseSchema,
  deviceTokenUnregisterResponseSchema,
  type DeviceTokenRegisterRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createDevicesResource(ctx: RequestContext) {
  return {
    register(input: DeviceTokenRegisterRequest) {
      const body = deviceTokenRegisterRequestSchema.parse(input);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/devices",
        body,
        dataSchema: deviceTokenRegisterResponseSchema,
        auth: true,
      });
    },

    // Detach one device (when token provided) or all my devices (no body).
    unregister(token?: string) {
      return requestJson(ctx, {
        method: "DELETE",
        path: "/me/devices",
        body: token ? { token } : undefined,
        dataSchema: deviceTokenUnregisterResponseSchema,
        auth: true,
      });
    },
  };
}
